var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-modal",
    {
      ref: "modal",
      attrs: {
        width: _vm.width,
        height: _vm.height,
        role: "alertdialog",
        describedby: "_confirm-msg"
      }
    },
    [
      _c("article", {
        directives: [
          {
            name: "markdown",
            rawName: "v-markdown._blank",
            value: _vm.msg,
            expression: "msg",
            modifiers: { _blank: true }
          }
        ],
        attrs: { id: "_confirm-msg", dir: "auto" }
      }),
      _c(
        "template",
        { slot: "buttons" },
        [
          _vm.dismissable
            ? _c(
                "div",
                { staticClass: "_mdismiss" },
                [
                  _c(
                    "ib-checkbox",
                    {
                      staticClass: "fs7",
                      model: {
                        value: _vm.dismiss,
                        callback: function($$v) {
                          _vm.dismiss = $$v
                        },
                        expression: "dismiss"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$locale.data.dismissable))]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "ib-button-group",
            [
              _c(
                "ib-button",
                { attrs: { bind: "Escape" }, on: { click: _vm.onCancel } },
                [_vm._v(_vm._s(_vm.verbCancel || _vm.$locale.data.Cancel))]
              ),
              _c(
                "ib-button",
                {
                  attrs: { tone: _vm.tone, autofocus: "" },
                  on: { click: _vm.onAccept }
                },
                [_vm._v(_vm._s(_vm.verb || _vm.$locale.data.Accept))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }